import { DealerLocationID } from "./DealerLocation";

export type ExactStandaloneLicenseID = number;

export interface ExactStandaloneLicense {
  created_on: string;
  updated_on: string;
  id: ExactStandaloneLicenseID;
  exact_item_id: string; // ID of the exact item coupled to this license
  quantity: number; // Quantity of the item in the license
  price: number | null; // Price of the item
  description: string; // Description of the item, if present it overrides the description of the item in exact only for this license
  invoice_on: string | null; // On which date should this license be invoiced
  invoiced: boolean; // Has an invoice for this category been sent, only for onetime categories
  dealer_location_id: DealerLocationID; // Location identifier
  dealer_location_name?: string; // The name of the location of this license
}
